import { FC } from "react";
import { FormControl, IconButton, Stack, Typography } from "@mui/material";

import { Tune } from "@mui/icons-material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { ResourceExplorerDataGridViewTab } from "../../../../pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/column-view-tabs/ResourceExplorerDataGridViewTab";
import { GlobalFilter } from "@/storybook/data-grid/toolbar/GlobalFilter";
import { ResourceExplorerGroupingNullable } from "@/services/cloudchipr.api";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerInternalGroupingLabelByGroupingSelector } from "@/store/resource-explorer/selectors/internal/resourceExplorerInternalGroupingLabelByGroupingSelector";

interface InternalResourceExplorerCardDataGridToolbarProps {
  groupBy: ResourceExplorerGroupingNullable;
  organisationId: string;
}

export const InternalBillingExplorerCardGridToolbar: FC<
  InternalResourceExplorerCardDataGridToolbarProps
> = ({ groupBy, organisationId }) => {
  const groupingLabel = useAppSelector((state) =>
    resourceExplorerInternalGroupingLabelByGroupingSelector(
      state,
      organisationId,
      groupBy,
    ),
  );
  const label = groupingLabel?.plural ?? "";

  return (
    <Stack direction="row" justifyContent="space-between" spacing={3}>
      <Stack direction="row" paddingY={2} alignItems="center" overflow="hidden">
        <Typography variant="body1" sx={{ pl: 1.5 }}>
          {label}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <GlobalFilter
            globalFilter=""
            setGlobalFilter={() => {}}
            placeholder="Search"
            size="xsmall"
            fullWidth
          />
        </FormControl>

        <Stack direction="row" bgcolor="grey.200" borderRadius={1} p={0.25}>
          <ResourceExplorerDataGridViewTab
            value="total"
            onChange={() => {}}
            selected
          />
          <ResourceExplorerDataGridViewTab
            value="granular"
            onChange={() => {}}
            selected={false}
          />
        </Stack>

        <IconButton size="small">
          <DownloadOutlinedIcon fontSize="small" />
        </IconButton>

        <IconButton size="small">
          <Tune fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
};
